import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getInvoices } from "@insite/client-framework/Services/InvoiceService";
import translate from "@insite/client-framework/Translate";
import { InvoiceModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<{}>;

export const DispatchBeginExportOrders: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderHistory/BeginExportOrders",
    });
};

export const ExportData: HandlerType = async props => {
    const { unparse } = await import(/* webpackChunkName: "papaparse" */ "papaparse");

    const data: any[] = [];
    const state = props.getState();
    const language = state.context.session.language;
    const invoicesData = (invoice: InvoiceModel) => {
        return [
            invoice.invoiceDate
                ? getLocalizedDateTime({
                      dateTime: new Date(invoice.invoiceDate),
                      language: language,
                  })
                : "",
            invoice.invoiceNumber,
            invoice.invoiceType,
            invoice.customerPO,
            invoice.invoiceTotalDisplay,
            invoice.currentBalanceDisplay,
            invoice.dueDate
                ? getLocalizedDateTime({
                      dateTime: new Date(invoice.dueDate),
                      language: language,
                  })
                : "",
            invoice.terms,
            `${invoice.stCompanyName} ${invoice.btAddress1} ${invoice.btAddress2} ${invoice.shipToCity} ${invoice.shipToState}`,
            invoice.status,
        ];
    };

        const invoicesHistoryResult = await getInvoices({
            ...state.pages.invoiceHistory.getInvoicesParameter,
            page: 1,
            pageSize: 9999,
        });
        if (invoicesHistoryResult && invoicesHistoryResult.invoices) {
            invoicesHistoryResult.invoices.forEach(invoice => {
                data.push(invoicesData(invoice));
            });
        }
    
    const documentData = {
        fields: [
            translate("Date"),
            translate("Invoice #"),
            translate("Type"),
            translate("PO #"),
            translate("Total"),
            translate("Balance"),
            translate("Due Date"),
            translate("Terms"),
            translate("Ship To / Pick Up"),
            translate("Status"),
        ],
        data,
    };

    const csv = unparse(documentData);

    let csvBlob;
    if(invoicesHistoryResult && invoicesHistoryResult?.invoices?.length ){
        if(invoicesHistoryResult?.invoices?.length > 0){
            csvBlob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8;" });
        } else {
            csvBlob = new Blob([invoicesHistoryResult?.properties?.invoiceCsv], { type: 'text/csv' });
        }
    } else{
        csvBlob = new Blob([invoicesHistoryResult?.properties?.invoiceCsv], { type: 'text/csv' });
    }

    const fileName = `InvoiceHistory.csv`;
    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(csvBlob);
    downloadLink.setAttribute("download", fileName);
    downloadLink.click();
};

export const DispatchCompleteExportOrders: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderHistory/CompleteExportOrders",
    });
};

export const chain = [DispatchBeginExportOrders, ExportData, DispatchCompleteExportOrders];

const exportInvoiceHistory = createHandlerChainRunner(chain, "ExportInvoiceHistory");
export default exportInvoiceHistory;
